import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Hat: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M1.61266 9.99079L6.13301 11.7849V16.6126C6.12441 17.4436 6.47847 18.2252 7.07661 18.6949C7.82426 19.2663 9.28695 19.9492 12 19.9492C14.1149 19.9492 15.74 19.5505 16.8314 18.764V18.763C17.4777 18.2992 17.8696 17.484 17.867 16.6077V11.7848L19.7 11.0575V13.7102C19.3855 13.8355 19.138 14.1188 19.028 14.48C18.918 14.8412 18.9575 15.2398 19.1362 15.5636L18.7023 18.0544C18.594 18.6584 18.9085 19.2554 19.425 19.4262C19.8435 19.5604 20.287 19.5604 20.7063 19.4262C21.2237 19.2555 21.5399 18.6564 21.4308 18.0505L20.9968 15.5626C21.1755 15.2389 21.2151 14.8402 21.1051 14.48C20.9951 14.1188 20.7476 13.8355 20.433 13.7102V10.7664L22.3873 9.99077C22.7542 9.84471 23 9.44701 23 9.00093C23 8.55484 22.7542 8.15815 22.3873 8.01207L12.2956 4.00547C12.104 3.93047 11.896 3.93047 11.7044 4.00547L1.61274 8.01207C1.24578 8.15813 1 8.55484 1 9.00093C1 9.44701 1.2457 9.84472 1.61266 9.99079ZM20.0669 14.4751C20.2148 14.4751 20.3488 14.5778 20.4055 14.7347C20.4623 14.8926 20.4305 15.0732 20.3256 15.1936C20.2208 15.314 20.0635 15.3505 19.926 15.2853C19.7894 15.2202 19.7 15.0663 19.7 14.8965C19.7 14.6636 19.8641 14.4751 20.0669 14.4751ZM20.5026 18.6179C20.2165 18.7087 19.9148 18.7087 19.6287 18.6179C19.4791 18.5676 19.3889 18.3929 19.4215 18.2182L19.7885 16.1132L19.7876 16.1123C19.9698 16.1734 20.1632 16.1734 20.3445 16.1123L20.7115 18.2133C20.745 18.39 20.6539 18.5676 20.5026 18.6179ZM17.1331 16.6077C17.1357 17.1939 16.8736 17.7396 16.4405 18.0495C15.7727 18.5321 14.4596 19.1064 12 19.1064C9.46999 19.1064 8.14647 18.5015 7.48317 17.9932C7.08957 17.6804 6.85753 17.1623 6.86699 16.6126V12.075L11.7035 13.9954C11.8951 14.0714 12.1039 14.0714 12.2956 13.9954L17.1329 12.075L17.1331 16.6077ZM1.85257 8.80743L11.9442 4.80083V4.80182C11.9803 4.78701 12.0198 4.78701 12.0559 4.80182L22.1476 8.80842V8.80743C22.2189 8.83704 22.267 8.91402 22.267 9.00086C22.267 9.0877 22.2189 9.16567 22.1476 9.19428L20.0326 10.0341L14.1982 8.97224C14.1784 8.04162 13.2211 7.31725 11.9999 7.31725C10.7667 7.31725 9.79993 8.05741 9.79993 9.00185C9.79993 9.94629 10.7667 10.6864 11.9999 10.6864V10.6855C12.7373 10.7358 13.4549 10.4032 13.9559 9.78149L18.5605 10.6193L12.0551 13.2011C12.0198 13.2149 11.9812 13.2149 11.9451 13.2011L1.85255 9.19446C1.78122 9.16584 1.7331 9.08788 1.7331 9.00103C1.7331 8.91419 1.78124 8.83704 1.85257 8.80743ZM13.467 9.00086C13.467 9.39856 12.8397 9.84265 12.0001 9.84265C11.1605 9.84265 10.5331 9.39758 10.5331 9.00086C10.5331 8.60315 11.1605 8.15907 12.0001 8.15907C12.8397 8.15907 13.467 8.60414 13.467 9.00086Z'
        fill='url(#paint0_linear_12280_30167)'
        stroke='url(#paint1_linear_12280_30167)'
        strokeWidth='0.8'
      />
      <defs>
        <linearGradient
          id='paint0_linear_12280_30167'
          x1='5.55569'
          y1='5.04024'
          x2='11.408'
          y2='21.1684'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_30167'
          x1='5.55569'
          y1='5.04024'
          x2='11.408'
          y2='21.1684'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Hat;
